module.exports = __webpack_public_path__ + "static/img/fqycc12-benefit-top-bg.a306c2b7.png";